/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Team_Plan_RequiredInputs */



/**
* | output |
* | --- |
* | "Team plan required" |
*
* @param {Compliance_Copilot_Team_Plan_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_team_plan_required = /** @type {((inputs?: Compliance_Copilot_Team_Plan_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Team_Plan_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team-Plan erforderlich")
	return /** @type {LocalizedString} */ ("Team plan required")
});